export const Labels={
    duration:'Duration',
    workflows:'Repositories',
    cfgWf: 'Configured workflow',
    cfgName:'Configuration name',
    chWorkflow:'Choose workflow',
    roles:'Roles',
    argType:'Argument type',
    argKey:'Argument key',
    argValue:'Argument value',
    toolName:'Tool name',
    toolVrsn:'Tool version',
    selectTypes:'Select license type',
    selectFlType: 'Select floating type',
    selectOs:'Select OS',
    avlCount:'Available count',
    typeLabel:"Type",
    osLabel:"Operating System",
    labelLabel:"Label",
    thresHold:'Threshold',
    toolType: 'Floating license manager type',
    FltIpAddr:'Floating license manager IP address',
    ipAddr: 'Ip address',
    fltLicName: 'Floating license name',
    minCnt: 'Minimum count',
    alwFlr:'Allow failure',
    scheduleNm: 'Schedule name',
    scheduleTime: 'Schedule time',
    repeat: 'Repeat',
    wfName: 'Workflow name',
    target: 'Target',
    pckgNm: 'Sole package name',
    tgtNm: 'Sole target name',
    swNm: 'Software name',
    swVer: 'Software version',

    /**Dates */
    startDate: 'Start date',
    endDate: 'End date',

    name: 'Name',
    desc: 'Description',

    /**Status */
    success: 'Success',
    failed: 'Failed',
    inprogress: 'In progress',
    queued: 'Queued',
    requested: 'Requested',
    dispatched: 'Dispatched',
    githubAbort: 'GitHub abort',
    systemAbort: 'System abort',
}

export const ToolTips = {
    "open_dashboard":"OPTIMUS CICD Dashboard"
}

export const Keys = {
    runnerDetails : "runner_details"
}